"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.run = void 0;
const socket_1 = require("../socket");
const run = () => {
    console.log("Running PP hot-reloading.");
    socket_1.socket.on("run-id", (runID) => {
        if (document.body.dataset.runId !== runID) {
            location.reload();
        }
    });
};
exports.run = run;
